import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-google-recaptcha',
  templateUrl: './google-recaptcha.component.html',
  styleUrls: ['./google-recaptcha.component.css'],
})
export class GoogleRECAPTCHAComponent {
  sitekey = '6Lcj9MwpAAAAAJOEk0ji5J9OUvo_zPpQr9vQfsUs';
  forms!: FormGroup;
  script!: HTMLScriptElement;
  GoogleRE_CAPTCHA_KEY = environment.GoogleRE_CAPTCHA_KEY;
  @Input() needToCheck!: boolean;
  @Output() tokenId = new EventEmitter<string>();
  constructor(
    public formBuilder: FormBuilder,
    @Inject(DOCUMENT) private dom: any,) {
  }

  ngOnInit() {
    this.forms = this.formBuilder.group(
      {
        recaptchaReactive: ['', Validators.required],
      }
    );
    this.script = this.dom.createElement('script');
    this.dom.head.appendChild(this.script);
    this.script.setAttribute('src', 'https://www.google.com/recaptcha/api.js');
  }
  resolved(event: any) {
    this.tokenId.emit(event);
  }
}
